import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../NavigationContainer.vue";
import { ref, onMounted, reactive, onUpdated } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import NewsinfoDataService from "@/services/NewsinfoDataService";
import { useRouter } from "vue-router";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const router = useRouter();
const isLoading = ref(false);
const alertMessage = ref("null");
const alertState = ref("neutral");
const isShowing = ref(false);
const i18n = useI18n();
const newsInfo = reactive([]);
const modalSubject = reactive([]);
const modalBody = reactive([]);
const getData = ref(false);

onMounted(function () {
  isLoading.value = true;
  getNewsAndFAQ();
});

const linkBack = () => {
  router.push("/");
};

const getNewsAndFAQ = () => {
  isLoading.value = true;
  newsInfo.splice(0);
  const data = { isShowing: isShowing.value };

  //二回目実行にアラートメッセージが表示修正
  alertMessage.value = "null";
  alertState.value = "neutral";

  // get Old News
  NewsinfoDataService.getOldNews(data)
    .then((response: ResponseData) => {
      if (response.data.length !== 0) {
        let date;
        for (let info of response.data) {
          if (info["startDate"] != null) {
            date = info["startDate"].substr(0, 10);
          }
          info["startDate"] = date;
          newsInfo.push(info);
        }
      }
      getData.value = true;
      isLoading.value = false;
    })
    .catch((e: Error) => {
      console.log(e);
      alertMessage.value = i18n.t("err008");
      alertState.value = "error";
      isLoading.value = false;
    });
};

/** プレビューボタン押下時の処理関数 */
const modalShow = (index) => {
  modalSubject.splice(0);
  modalBody.splice(0);
  for (let key of Object.keys(newsInfo)) {
    if (key == index) {
      modalSubject.push(newsInfo[key].Subject);
      var splitData = newsInfo[key].Content.split(/^/gm);
      for(let oneLine of splitData){
        modalBody.push(oneLine);
      }
      break;
    }
  }
};

onUpdated(function () {
  isLoading.value = false;
});

const __returned__ = { router, isLoading, alertMessage, alertState, isShowing, i18n, newsInfo, modalSubject, modalBody, getData, linkBack, getNewsAndFAQ, modalShow, Navigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})